__webpack_require__.p = "https://medicare-stage.curebay.in/";